<template>
  <div id="app">
        <router-view  v-if="isRouterAlive"/>          
  </div>
</template>
<script>
export default {
  name:'app',
  provide :function() {
      return {
        reload:this.reload
      }
  },
  data:function(){
    return {
      isRouterAlive:true
    }
  },
  methods:{
    reload:function(){
      this.isRouterAlive=false;
      this.$nextTick(function(){
          this.isRouterAlive=true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
.warp{
  width: 97%;
  margin: 0 auto;
}
</style>


